import { makeStyles } from "tss-react/mui";
const drawerWidth= 240;

export default makeStyles()((theme) => ({
  toolbar: {
    height: "80px",
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "220px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      flexWrap: "wrap",
    },
  },

  menuButton: {
    outline: "none",
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },

  drawer:{
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink:0
    },
  },

  drawerPaper: {
    width:drawerWidth,
  },

  linkButton: {
    '&:hover':{
      color:"white !important",
      textDecoration :'none'
    },
  },

}));
